export const localize = (label: string, content: Array<string>) => {
  content.forEach((val, i) => {
    let count = "${count" + (i + 1) + "}";
    label = label.replace(count, val);
  });
  return label;
};
